import ManageContentContainer from "library/show/components/content/manage/ManageContentContainer"

const ManageAsessment = ({ step }) => (
  <ManageContentContainer prompt="Add content to take:" />
)

ManageAsessment.displayName = "ManageAsessment"

export default ManageAsessment
